import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from "@angular/core";

@Component({
  selector: "license-plate",
  templateUrl: "license-plate.html",
})
export class LicensePlateComponent implements OnInit, OnChanges {
  @Input()
  public license: string;

  public formattedLicense;

  public ngOnInit() {
    this.formattedLicense = this.format(this.license);
  }

  public ngOnChanges(changes: SimpleChanges): void {
    this.formattedLicense = this.format(this.license);
  }

  // Example: "04GFR3" becomes "04-GFR-3"
  private format(license: string) {
    return license
      ? license.replace(/(?:(\d)(?=[a-z]))|(?:([a-z])(?=\d))/gi, "$1$2-")
      : "";
  }
}



// WEBPACK FOOTER //
// ./src/components/license-plate/license-plate.ts